import ExaminationFinalization from './ExaminationFinalization';

export default ExaminationFinalization;
